<template>
  <v-layout
    justify-center
    wrap
    fill-height
    style="position: relative"
    class="hub-background"
  >
    <transition name="fade" mode="out-in" appear>
      <v-flex
        xs12
        class="ma-3 header"
        v-on-clickaway="closeAway"
        style="position: relative"
      >
        <div class="logo-badge">
          <img
            class="logo"
            src="../assets/logos/weezie_icon.png"
          />
        </div>

        <div class="header-item-container" :key="showManagementHub">
          <header-item
            v-for="item in headerItems"
            :key="item.route"
            :title="item.title"
            :short-title="item.shortTitle"
            :loading="loading"
            :route="item.route"
            :permission-name="item.permissionName"
            :trackingIdentifier="item.permissionName"
            :inactive="item.disabled"
            :redirect="item.redirect"
            :show="item.show"
            :icon="item.icon"
            @click="toggleManagementHub"
          />
        </div>

        <v-layout row justify-end align-center id="badge">
          <v-badge
            :content="null"
            :value="messages.length"
            color="red"
            dot
            overlap
            class="notifications-badge"
          >
            <v-btn icon @click="onNotificationButtonClick">
              <v-icon color="#231E46" size="24"> notifications_none </v-icon>
            </v-btn>
          </v-badge>

          <notifications-window
            top="75px"
            :right="width"
            v-show="notificationWindow"
            :notificationOpen="notificationWindow"
            @notifications="setNotificationNumber"
          />
            <v-flex shrink class="hub-user-info-container" id="userInfoContainer">
              <user-button
                :show-avatar="false"
                locationInApp="hub"
                avatarWidth="60px"
                avatarHeight="60px"
                @click.native="toggleUserWindow"
              />
            </v-flex>
        </v-layout>

        <user-window
          v-show="userWindow"
          right="10px"
          top="75px"
          :twoFactorAuthenticationPopUp="false"
        />
      </v-flex>
    </transition>

    <v-flex xs11 class="hub-scroll scroll-fire-fox">
      <div
        :class="showManagementHub ? 'management-hub-items-container' : 'hub-items-container'"
        :key="showManagementHub ? 'management-hub-items-container' : 'hub-items-container'"
        :style="{ 'height': showManagementHub ? '97%' : '69%'}"
      >
        <hub-item
          v-if="!item.children"
          v-for="item in mainTiles"
          :key="item.route"
          :title="item.title"
          :description="item.description"
          :route="item.route"
          :permission-name="item.permissionName"
          :background-image="item.backgroundImage"
          :loading="loading"
          :dev="item.dev"
          :inactive="item.disabled"
          :class="item.size"
          :item-size="item.size"
          :redirect="item.redirect"
          :trackingIdentifier="item.permissionName"
        />

        <div v-else  class="hub-item-children-container" :key="'hub-item-children-container'" :style="[{ 'height': showManagementHub ? item.height : 'auto'}, item.style]">
          <div v-if="item.title" class="hub-item-children-title">{{ item.title }}</div>
          <hub-item
            v-for="child in item.children"
            :key="child.route"
            :title="child.title"
            :description="child.description"
            :route="child.route"
            :permission-name="child.permissionName"
            :background-image="child.backgroundImage"
            :loading="loading"
            :dev="child.dev"
            :inactive="child.disabled"
            :class="child.size"
            :item-size="child.size"
            :redirect="child.redirect"
            :trackingIdentifier="child.permissionName"
          />
        </div>
      </div>

      <div class="secondary-tiles-container" :key="'secondary-tiles-container'" v-if="secondaryTiles.length > 0">
        <hub-item
          v-for="item in secondaryTiles"
          :key="item.route"
          :title="item.title"
          :description="item.description"
          :route="item.route"
          :permission-name="item.permissionName"
          :background-image="item.backgroundImage"
          :loading="loading"
          :dev="item.dev"
          :inactive="item.disabled"
          :class="item.size"
          :item-size="item.size"
          :redirect="item.redirect"
          :trackingIdentifier="item.permissionName"
        />
      </div>
    </v-flex>

    <v-flex
      xs12
      class="ma-3"
      style="position: relative; max-width: 79%;"
    >
      <hub-footer :loading="loading" :host="host" :version="version"/>
    </v-flex>

    <loading-spinner
      :active.sync="loading"
      :is-full-page="true"
      color="accent"
      :opacity="0"
    />

    <activate-two-authentication-dialog
      :open="opened2FArequired"
      @close="opened2FArequired = false"
      @activateAuthenticate="twoFactorAuthentication = true"
    />
  </v-layout>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import NotificationsSVG from "@/assets/management/notifications.svg";
import UserButton from "@/components/User/Navbar/UserButton";
import UserWindow from "@/components/User/Navbar/UserWindow/UserWindow";
import HeaderItem from "@/components/Hub/HeaderItem";
import HubFooter from "@/components/Hub/HubFooter";
import HubItem from "@/components/Hub/HubItem";
import LoadingSpinner from "vue-loading-overlay";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { mapActions } from "vuex";
import endpoints from "@/utils/endpoints";
import ActivateTwoAuthenticationDialog from "@/components/User/Navbar/UserWindow/ActivateTwoAuthenticationDialog";
import { managementViewMixin } from "@/mixins/management/managementViewMixin";

export default {
  name: "Hub",

  components: {
    HubItem,
    UserWindow,
    UserButton,
    LoadingSpinner,
    NotificationsSVG,
    ActivateTwoAuthenticationDialog,
    HeaderItem,
    HubFooter,
  },

  mixins: [clickaway, checkPermissionsMixin, managementViewMixin],

  data() {
    return {
      userWindow: false,
      notificationWindow: false,
      loading: false,
      messages: [],
      width: "0",
      opened2FArequired: false,
      version: "V2.172",
      showManagementHub: false,
    };
  },

  computed: {
    mainTiles() {
      let items = [];

      if (this.showManagementHub) {
        items = [
          {
            title: this.$i18n.t("StockManagement"),
            shortTitle: this.$i18n.t("Stock"),
            description: this.$i18n.t("StockManagementDescription"),
            route: "",
            backgroundImage: "",
            size: "md",
            permissionName: "module_stock_management",
            dev: false,
            showInBidding: false,
            disabled:
              this.getModuleState("module_stock_management") ||
              !this.userHasPermission("module_stock_management"),
            height: '100%',
            children: [
              {
                title: this.$i18n.t("Warehouse"),
                description: "",
                route: "stock-management",
                backgroundImage: "",
                size: "m",
                permissionName: "module_stock_management",
                dev: false,
                showInBidding: true,
                disabled: !this.userHasPermission("module_stock_management")
              },
            ]
          },
          {
            title: this.$i18n.t("ProjectManagement"),
            shortTitle: this.$i18n.tc("Workspace", 1),
            description: "",
            route: "",
            backgroundImage: "",
            size: "md",
            permissionName: "module_project_management",
            dev: false,
            showInBidding: true,
            disabled:
              this.getModuleState("module_project_management") ||
              !this.userHasPermission("module_project_management"),
            height: '100%',
            children: [
              {
                title: this.$i18n.t("Directory"),
                description: "",
                route: "directory",
                backgroundImage: "",
                size: "m",
                permissionName: "workspace_list",
                dev: false,
                disabled: !this.userHasPermission("workspace_list"),
              },
              //hiden until further notice
              // {
              //   title: null,
              //   description: "",
              //   route: "project-management/workspaces/export",
              //   backgroundImage: "",
              //   size: "m",
              //   permissionName: "export_store",
              //   dev: false,
              //   disabled: true,
              // },
            ]
          },
          {
            title: this.$i18n.t("External"),
            shortTitle: this.$i18n.t("External"),
            description: "",
            route: "",
            backgroundImage: "",
            size: "md",
            permissionName: "module_project_management",
            dev: false,
            showInBidding: true,
            disabled: !this.userHasPermission("third_party_apis_service_list"),
            height: 'calc(33% - 7.5px)',
            children: [
              {
                title: this.$i18n.tc("Integration", 2),
                description: "",
                route: "integrations",
                backgroundImage: "",
                size: "sm",
                permissionName: "third_party_apis_service_list",
                dev: false,
                disabled: !this.userHasPermission("third_party_apis_service_list"),
              },
              {
                title: this.$i18n.tc("Map", 2),
                description: "",
                route: "maps",
                backgroundImage: "",
                size: "sm",
                permissionName: "third_party_apis_consumables_list",
                dev: false,
                disabled: !this.userHasPermission("third_party_apis_consumables_list") || !this.userHasPermission("third_party_apis_service_list"),
              },
            ]
          },
          {
            title: this.$i18n.t("Data"),
            shortTitle: this.$i18n.t("Data"),
            description: "",
            route: "",
            backgroundImage: "",
            size: "md",
            permissionName: "",
            dev: false,
            showInBidding: true,
            disabled: false,
            height: 'calc(67% - 7.5px)',
            style: { 'margin-top': '15px' },
            children: [
              {
                title: this.$i18n.t("GlobalSearch"),
                description: "",
                route: "global-search",
                backgroundImage: "",
                size: "sm",
                permissionName: "module_project_management",
                dev: false,
                disabled: !this.userHasPermission("module_project_management"),
              },
              {
                title: this.$i18n.t("Delete"),
                description: "",
                route: "/data/deleteLayers",
                backgroundImage: "",
                size: "sm",
                permissionName: "module_project_management",
                dev: false,
                disabled: !this.userHasPermission("module_project_management"),
              },
              {
                title: this.$i18n.tc("ImportNoun", 1),
                description: "",
                route: "/data/import",
                backgroundImage: "",
                size: "sm",
                permissionName: "import_list",
                dev: false,
                disabled: !this.userHasPermission("import_list"),
              },
              {
                title: this.$i18n.tc("ImportTemplate", 2),
                description: "",
                route: "/import",
                backgroundImage: "",
                size: "sm",
                permissionName: "import_mapper_list",
                dev: false,
                disabled: !this.userHasPermission("import_mapper_list"),
              },
            ]
          },
          {
            title: this.$i18n.t("SystemSettings"),
            shortTitle: this.$i18n.t("System"),
            description: "",
            route: "",
            backgroundImage: "",
            size: "md",
            permissionName: "",
            dev: false,
            showInBidding: true,
            disabled: false,
            height: 'calc(50% - 7.5px)',
            children: [
              {
                title: this.$i18n.t("ListsSettings"),
                description: "",
                route: "lists",
                backgroundImage: "",
                size: "sm",
                permissionName: "list_list",
                dev: false,
                disabled: !this.userHasPermission("list_list"),
              },
              {
                title: this.$i18n.tc("CustomFields", 2),
                description: "",
                route: "/custom-fields",
                backgroundImage: "",
                size: "sm",
                permissionName: "custom_field_list",
                dev: false,
                disabled: !this.userHasPermission("custom_field_list"),
              },
              {
                title: this.$i18n.t("NetworkRules"),
                description: "",
                route: "network-rules",
                backgroundImage: "",
                size: "sm",
                permissionName: "network_rule_list",
                dev: false,
                disabled: !this.userHasPermission("network_rule_list"),
              },
            ]
          },
          {
            title: this.$i18n.tc("Account", 2),
            shortTitle: this.$i18n.tc("Account", 2),
            description: "",
            route: "",
            backgroundImage: "",
            size: "md",
            permissionName: "",
            dev: false,
            showInBidding: true,
            disabled: false,
            height: 'calc(50% - 7.5px)',
            style: { 'margin-top': '15px' },
            children: [
              {
                title: this.$i18n.tc("Company", 2),
                description: "",
                route: "/companies",
                backgroundImage: "",
                size: "sm",
                permissionName: "company_list",
                dev: false,
                disabled: !this.userHasPermission("company_list"),
              },
              {
                title: this.$i18n.tc("Role", 2),
                description: "",
                route: "/roles",
                backgroundImage: "",
                size: "sm",
                permissionName: "role_list",
                dev: false,
                disabled: !this.userHasPermission("role_list"),
              },
              {
                title: this.$i18n.tc("User", 2),
                description: "",
                route: "/users",
                backgroundImage: "",
                size: "sm",
                permissionName: "user_list",
                dev: false,
                disabled: !this.userHasPermission("user_list"),
              },
            ]
          },
        ]
      } else {
        items = [
          {
            title: this.$i18n.t("module_network"),
            description: this.$i18n.t("FibercloudDesc"),
            route: `${endpoints.FIBER_CLIENT_URL}pni`,
            backgroundImage: "hub_fibercloud.jpg",
            permissionName: "module_network",
            size: "xlg",
            dev: false,
            redirect: true,
            showInBidding: false,
            disabled:
              this.getModuleState("module_network") ||
              !this.userHasPermission("module_network"),
          },
          {
            title: this.$i18n.t("GISNET"),
            description: this.$i18n.t("WorkspacesDescription"),
             route:
              `${endpoints.FIBER_CLIENT_URL}v3`,
            redirect: false,
            backgroundImage: "hub_field_work.jpeg",
            permissionName: "module_design",
            size: "lg",
            dev: false,
            redirect: true,
            showInBidding: true,
            disabled:
              this.getModuleState("module_design") ||
              !this.userHasPermission("module_design"),
          },
          {
            title: this.$i18n.t("BI"),
            description: this.$i18n.t("BusinessIntelligenceDescription"),
            route: "business-intelligence",
            backgroundImage: "hub_business_intelligence.png",
            permissionName: "module_business_intelligence",
            size: "lg",
            dev: false,
            showInBidding: false,
            disabled:
              this.getModuleState("module_business_intelligence") ||
              !this.userHasPermission("module_business_intelligence"),
          },
        ]
      }

      return items;
    },

    secondaryTiles() {
      let items = [
        {
          title: this.$i18n.t("Support"),
          description: "",
          route: "support/technical-support/tickets",
          backgroundImage: null,
          size: "sm",
          permissionName: "third_party_apis_youtrack_issues_list",
          dev: false,
          showInBidding: false,
          disabled: !this.userHasPermission(
            "third_party_apis_youtrack_issues_list"
          ),
        },
        {
          title: this.$i18n.t("Sandbox"),
          description: null,
          route: "sandbox",
          backgroundImage: null,
          size: "sm",
          permissionName: null,
          dev: false,
          showInBidding: false,
          disabled: true,
        },
        {
          title: this.$i18n.tc("AssetReservation", 1),
          description: this.$i18n.t("Management"),
          route: "asset-reservation-management",
          backgroundImage: "hub_asset_reservation_management.jpg",
          size: "sm",
          permissionName: "module_asset_reservation",
          dev: false,
          showInBidding: false,
          disabled: true
            // this.getModuleState("module_asset_reservation") ||
            // !this.userHasPermission("module_asset_reservation"),
        },
        {
          title: this.$i18n.tc("Task", 1),
          description: this.$i18n.t("Management"),
          route: "tasks-management",
          backgroundImage: "hub_field_management.jpg",
          size: "sm",
          permissionName: "module_field_management",
          dev: false,
          showInBidding: false,
          disabled: true
            // this.getModuleState("module_field_management") ||
            // !this.userHasPermission("module_field_management"),
        },
      ];

      return this.showManagementHub ? [] : items;
    },

    headerItems() {
      let items = [
        {
          title: this.$i18n.t("SystemManagement"),
          shortTitle: this.$i18n.t("System"),
          description: this.$i18n.t("SystemManagementDescription"),
          route: null,
          redirect: false,
          backgroundImage: "hub_system_management.jpg",
          size: "md",
          permissionName: null,
          dev: false,
          show: !this.showManagementHub,
          disabled: !(this.isSuperAdmin || this.isAdmin || this.isManager)
        },
        {
          title: this.$i18n.t("Home"),
          shortTitle: this.$i18n.t("Home"),
          description: this.$i18n.t("Home"),
          route: null,
          redirect: false,
          icon: 'mdi-chevron-left',
          backgroundImage: null,
          size: "md",
          permissionName: null,
          dev: false,
          show: this.showManagementHub,
          disabled: false
        },
      ]

      return items;
    },

    allItems() {
      let items = this.mainTiles.concat(this.secondaryTiles, this.headerItems);

      return items;
    },
    isBidding() {
      return sessionStorage.getItem("is_bidding") === "true";
    },

    permissionsWereLoaded() {
      return this.isSuperAdmin ? true : this.$store.getters.getUserPermissions.length > 0;
    },

    host() {
      let host = (new URL(window.location.href)).host;
      let hostName = host.split(".")[0];
      switch (hostName) {
        case "airband":
          return "Airband"
        case "tdf":
          return "TDF"
        case "rbbsh":
          return "RBBSH"
        case "united":
          return "United"
        case "gigaloch":
          return "Gigaloch"
        case "zetalink":
          return "Zetalink"
        default:
          return "Weezie"
      }
    },
  },

  watch: {
    permissionsWereLoaded() {
      if (this.permissionsWereLoaded) {
        if (this.userHasPermission("list_list")) {
          this.GET_ALL_LISTS();
        }
        this.loading = false;

        if (!this.isSuperAdmin) {
          this.checkUserHasAccessSingleModule();
        }
      }
    },
  },

  beforeMount() {
    this.showManagementHub = false;
  },

  mounted() {
    if (this.permissionsWereLoaded) {
      if (this.userHasPermission("list_list")) {
        this.GET_ALL_LISTS();
      }
      this.loading = false;

      if (!this.isSuperAdmin) {
        this.checkUserHasAccessSingleModule();
      }
    }
    this.getAllUsers();
    setTimeout(() => {
      this.companie2FArequired();
    }, 500);
  },

  methods: {
    ...mapActions(["GET_ALL_LISTS","fetchAllUsers"]),

    getAllUsers() {
      this.fetchAllUsers({})
    },

    companie2FArequired() {
      const is2FARequired = localStorage.getItem("2fa_required") === 'true';
      const userHas2fa = localStorage.getItem("user_has_2fa") === 'true';

      this.opened2FArequired = is2FARequired && userHas2fa === false ? true : false;
    },

    toggleUserWindow() {
      this.userWindow = !this.userWindow;
      this.notificationWindow = false;
    },
    /**
     * @param {Array} - Array of notifications
     * Checks if the readAt is null, if so, the notifications get filtered to message data property to use with vuetify badge
     */
    setNotificationNumber(data) {
      this.messages = data.filter((item) => !item.readAt);
    },
    /**
     * opens notification Window
     */
    onNotificationButtonClick() {
      this.width =
        document.getElementById("userInfoContainer").clientWidth + 15 + "px";
      this.notificationWindow = !this.notificationWindow;
      this.userWindow = false;
    },
    closeAway() {
      this.userWindow = false;
      this.notificationWindow = false;
    },

    getModuleState(permission) {
      let disabled = true;
      if (this) {
        this.$store.getters.modulesStates.forEach((module) => {
          if (module.permission_name === permission) {
            disabled = !module.status;
          }
        });
        return disabled;
      }
      return disabled;
    },

    /**
     * If the user has access to a single module the system will open directly the allowed module.
     */
    checkUserHasAccessSingleModule() {
      let userPermissions = this.$store.getters.getUserPermissions;
      let userModulePermissions = userPermissions.filter(permission => permission.type === "module");

      if (userModulePermissions.length === 1) {
        let module = this.allItems.find(
          (item) => item.permissionName === userModulePermissions[0].name
        );
        if (module && !module.disabled) {
          if (module.route.indexOf('https') === 0) {
            window.location.href = module.route;
          } else {
            this.$router.push({
              name: module.route,
            });
          }
        }
      } else if (userModulePermissions.length > 1) {
        let moduleInItems = [];
        userModulePermissions.forEach((moduleRole) => {
          let module = this.allItems.find(
            (item) => item.permissionName === moduleRole.name
          );
          if (module && !module.disabled) {
            moduleInItems.push(module);
          }
        });

        if (moduleInItems.length === 1) {
          this.$router.push({
            name: moduleInItems.route,
          });
        }
      }
    },

    toggleManagementHub() {
      this.showManagementHub = !this.showManagementHub;
      localStorage.setItem("managementHubIsOpen", this.showManagementHub);
    },
  },
};
</script>

<style scoped>
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 1s 0.5s;
  /* transition-delay: 1s; */
}

.hub-user-info-container {
  color: white;
}

.hub-items-container,
.management-hub-items-container {
  width: 85%;
  margin: 0 auto;
}

.hub-items-container {
  display: grid;
  grid-template-columns: repeat(4, minmax(100px, 1fr));
  grid-template-rows: repeat(auto-fit, minmax(75px, 1fr));
  grid-gap: 16px;

  align-content: start;
  justify-content: start;
  grid-auto-flow: dense;
}

.management-hub-items-container {
  column-gap: 15px;
  column-count: 4;
}

.badge {
  position: absolute;
  left: 10px;
  top: 10px;
}

.xlg {
  grid-column: span 2;
  grid-row: span 2;
}

.lg {
  grid-column: span 2;
  grid-row: span 1;
}
.md {
  grid-column: span 1;
  grid-row: span 1;
}
.sm {
  grid-column: span 1;
  grid-row: span 1;
}

.secondary-tiles-container {
  width: 85%;
  margin-top: 16px;

  grid-column: 1 / -1;
  grid-row: span 1;

  min-height: 150px;
  height: fit-content;
  align-content: stretch;
  background: rgba(255, 255, 255, 0.50);
  border-radius: 16px;
  padding: 30px 29px;
  box-shadow: 7px 9px 15px 0px rgba(0, 0, 0, 0.15);

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  grid-template-rows: repeat(1, 90px);
  grid-gap: 23px;
}

.secondary-tiles-container > .card {
  background: rgba(255, 255, 255, 0.25) !important;
  min-height: 90px;
}

.hub-scroll {
  height: 80vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hub-background {
  background-color: white;
  /* /('shape' at 'x from top left corner' 'y from top left corner', 'color') */
  /* background-image:
    radial-gradient(ellipse at 2% 0%, #FFFFFF 0%, transparent 27%),
    radial-gradient(ellipse at 99% 99%, #FFFFFF 0%, transparent 27%),
    radial-gradient(circle at 67% 53%, #29BDF0 0%, transparent 70%),
    radial-gradient(ellipse at 34% 93%, #00CE7C 3%, transparent 40%),
    radial-gradient(circle at 12% 85%, #f88e2bf4 0%, transparent 60%); */

  background: url("../assets/hub/hub-background.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.logo-badge {
  background-color: white;
  border-radius: 20px;
  height: 64px;
  width: 64px;
  position: relative;
  left: -10%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.logo {
  position: relative;
  height: 38px;
  top: 13px;
}

.notifications-badge {
  background: rgba(255, 255, 255, 0.50);
  border-radius: 4px;
  height: 32px;
  width: 32px;
  cursor: pointer;
  justify-content: center;
  display: flex;
  align-items: center;
  margin: 16px !important;
}

.notifications-badge > .v-btn:before,
.notifications-badge > .v-btn--active:not(:hover)::before,
.notifications-badge > .v-btn:focus:before {
  background-color: transparent !important;
  opacity: 0;
}

.notifications-badge > .v-btn >>> .v-ripple__container {
  display: none;
}

.header {
  max-width: 79% !important;
  display: flex;
  align-items: center;
}

.header-item-container {
  display: flex;
  gap: 24px;
  margin-left: 10px;
  position: absolute;
}

@media only screen and (max-width: 850px) {
  .logo-badge {
    height: 55px;
    width: 55px;
  }

  .logo {
    height: 30px;
    top: 12px;
  }
}

@media only screen and (max-width: 700px) {
  .logo-badge {
    height: 45px;
    width: 45px;
    border-radius: 16px;
  }

  .logo {
    height: 25px;
    top:11px
  }
}

@media only screen and (max-width: 1150px) {
  .header-item-container {
    margin-left: 7px;
  }
}

@media only screen and (max-height: 800px) {
  .hub-scroll {
    height: 77vh;
  }
}

@media only screen and (max-height: 600px) {
  .hub-scroll {
    height: 70vh;
  }
}

.hub-item-children-container {
  background: rgba(255, 255, 255, 0.50);
  border-radius: 16px;
  box-shadow: 6px 8px 13.5px 0px rgba(0, 0, 0, 0.15);
  gap: 16px;
  display: flex;
  flex-direction: column;
  padding: 15.6px;
  overflow-y: auto;
}

.hub-item-children-container > .card {
  background: rgba(255, 255, 255, 0.25) !important;
}

.hub-header-item-title {
  font-size: 16px;
  font-weight: 900;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.management-hub-items-container > .hub-item-children-container {
  padding: 20px 25px 30px 25px;
}

.hub-item-children-title {
  font-size: 20px;
  line-height: 20px;
  font-weight: 900;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  text-transform: uppercase;
  color: rgba(35, 30, 70, 0.25);
  text-align: start;
}
</style>



// WEBPACK FOOTER //
// src/views/Hub.vue